import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import store from '@/store';
import { Roles } from '@/typings/user';

import CButton from '@/components/shared/CButton';
import CanvasToolbarTopPreviewButtons from './previews/CanvasToolbarTopPreviewButtons.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CanvasToolbarTop',
  setup(__props) {

const canvas = computed(() => {
    return store.state.storeLayers?.canvas;
});

const flags = computed(() => {
    return store.state.storeLayers?.flags;
});

const isFeatureEnabled = computed(() => {
    if (flags.value?.isMyProductBases || flags.value?.isProductTemplate) {
        return false;
    }

    const user = store.state.user;
    if (!user) return false;

    const roles = user.AccessRoles?.Serialized.split(',');

    const isAdmin = roles?.includes(Roles.ADMIN);
    const impersonatedFromAdminUser = user.ImpersonatedFromAdminUser;
    const impersonatedFromChildUser = user.ImpersonatedFromChildUser;
    const isMultiPreview = roles?.includes(Roles.MULTI_PREVIEW);

    return Boolean((isAdmin || impersonatedFromAdminUser || isMultiPreview) && !impersonatedFromChildUser);
});

const onAddPreview = () => {
    if (!canvas.value) return;
    canvas.value.addPreview();
};

return { __sfc: true,canvas, flags, isFeatureEnabled, onAddPreview, CButton, CanvasToolbarTopPreviewButtons }
}

})